import {
  AccessTime,
  AccountCircle,
  Email,
  Phone,
  Person,
  InfoOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useCustomerUserDetailContext } from "contexts/CustomerUserDetailContext";
import moment from "moment";
import Status from "components/Shared/Status";

const formatDate = (dateString) => moment(dateString).format("MMMM Do, YYYY");

const CustomerUserBasicDetails = () => {
  const { customerUserDetail, loadingDetail } = useCustomerUserDetailContext();

  return !loadingDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountCircle color="primary" />}
                  title="Name"
                  subtitle={customerUserDetail?.name}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountCircle color="primary" />}
                  title="Customer ID"
                  subtitle={customerUserDetail?.customerUserID}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  title="Email"
                  icon={() => <Email color="primary" />}
                  subtitle={customerUserDetail?.email}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  title="Phone"
                  icon={() => <Phone color="primary" />}
                  subtitle={customerUserDetail?.phone}
                />
              </Grid>

              {customerUserDetail?.alternatePhone && (
                <Grid item md={4}>
                  <InformationTile
                    title="Alternate Phone"
                    icon={() => <Phone color="primary" />}
                    subtitle={customerUserDetail?.alternatePhone}
                  />
                </Grid>
              )}

              <Grid item xs={4}>
                <InformationTile
                  icon={() => <InfoOutlined color="primary" />}
                  title="Status"
                >
                  <Status isActive={customerUserDetail?.isActive} />
                </InformationTile>
              </Grid>

              {customerUserDetail?.userRef && (
                <Grid item md={4}>
                  <InformationTile
                    title="Connected User"
                    icon={() => <Person color="primary" />}
                    subtitle={customerUserDetail?.userRef?.name}
                  />
                </Grid>
              )}

              <Grid item md={4}>
                <InformationTile
                  title="Created At"
                  icon={() => <AccessTime color="primary" />}
                  subtitle={formatDate(customerUserDetail?.createdAt)}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  title="Updated At"
                  icon={() => <AccessTime color="primary" />}
                  subtitle={formatDate(customerUserDetail?.updatedAt)}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default CustomerUserBasicDetails;
